export default class PostTeilen {
  constructor() {
    if (!this.setVars()) return;

    this.setEvents();
  }

  setVars() {
    this.teilenContainer = document.querySelector('.postTeilen');
    if (!this.teilenContainer) return;

     
    this.teilenButton = this.teilenContainer.querySelectorAll('.postTeilen__teilenButton, .postTeilen__teilenClose');
    if (!this.teilenButton.length) return;

    this.teilenBox = this.teilenContainer.querySelector('.postTeilen__teilenBox');
    if (!this.teilenBox) return;

    return true;
  }

  setEvents() {
    this.teilenButton.forEach((singleButton) => {
      singleButton.addEventListener('click', this.toggleToilen.bind(this));
    });
  }

  toggleToilen() {
    this.teilenBox.classList.toggle('active');
  }
}
